import React, {useContext} from "react"
import PropTypes from "prop-types"

import {SubmissionDetailsComponent, MailInThanksComponent} from "../components"
import {ThankYouSection, Button, LinkButton} from "../components/styled"
import {AppContext} from "../components/context/AppContext"
import {createMarkup} from "../utils/Helpers"


import {ROUTE_PATHS} from "../utils/routes"

const TVISION_OFFERID = Number.parseInt(process.env.REACT_APP_TVISION_OFFER_ID)
const APPLETV_REBATE_OFFERID = Number.parseInt(process.env.REACT_APP_APPLETV_REBATE_OFFERID_ID)

const APPLE_FITNESS_P2 =  Number.parseInt(process.env.REACT_APP_APPLEFITNESSP2_OFFER_ID)
const APPLE_FITNESS_P3 =  Number.parseInt(process.env.REACT_APP_APPLEFITNESSP3_OFFER_ID)
const APPLE_TV_P1 =  Number.parseInt(process.env.REACT_APP_APPLETVP1_OFFER_ID)
const APPLE_TV_P3 =  Number.parseInt(process.env.REACT_APP_APPLETVP3_OFFER_ID)
const APPLE_TV_P4 =  Number.parseInt(process.env.REACT_APP_APPLETVP4_OFFER_ID)

const YT_BG_A = Number.parseInt(process.env.REACT_APP_YT_BASE_GROUPA_OFFER_ID)
const YT_BG_B = Number.parseInt(process.env.REACT_APP_YT_BASE_GROUPB_OFFER_ID)
const YT_BG_C = Number.parseInt(process.env.REACT_APP_YT_BASE_GROUPC_OFFER_ID)

const NursesTeachers_BG_A = Number.parseInt(process.env.REACT_APP_NursesTeachers_BASE_GROUPA_OFFER_ID)
const NursesTeachers_BG_B = Number.parseInt(process.env.REACT_APP_NursesTeachers_BASE_GROUPB_OFFER_ID)
const NursesTeachers_BG_C = Number.parseInt(process.env.REACT_APP_NursesTeachers_BASE_GROUPC_OFFER_ID)

const PHILO_OFFERID = Number.parseInt(process.env.REACT_APP_PHILO_OFFER_ID)

const PARAMOUNT_OFFERID = Number.parseInt(process.env.REACT_APP_PARAMOUNT_OFFER_ID)
const AAA_OFFERID = Number.parseInt(process.env.REACT_APP_AAA_OFFER_ID)
const OOMA_OFFERID = Number.parseInt(process.env.REACT_APP_OOMA_OFFER_ID)
const UNIVISION_OFFERID = Number.parseInt(process.env.REACT_APP_UNIVISION_OFFER_ID)
const AMAZONHINT_OFFERID = Number.parseInt(process.env.REACT_APP_AMAZON_OFFER_ID)
const AAA_REWARD_URL = process.env.REACT_APP_AAA_REWARD_REDIRECT_URL
const TIDAL_OFFERID = Number.parseInt(process.env.REACT_APP_TIDAL_OFFER_ID)
const SIRIUS_OFFERID = Number.parseInt(process.env.REACT_APP_SIRIUS_OFFER_ID)
const GOOGLEHINT_OFFERID = Number.parseInt(process.env.REACT_APP_GOOGLE_OFFER_ID)

const getOfferConfig = (offerId) => {
  const isAppleFitnessOffer = offerId === APPLE_FITNESS_P2 || offerId ===  APPLE_FITNESS_P3 || offerId ===  APPLE_TV_P1 
  const isAppleTvOffer = offerId ===  APPLE_TV_P1
  const isTVisionOffer = offerId === TVISION_OFFERID || offerId === APPLETV_REBATE_OFFERID
  const isYouTubeBaseOffers = offerId === YT_BG_A || offerId === YT_BG_B || offerId === YT_BG_C
  const isNursesTeachersOffers = offerId === NursesTeachers_BG_A || offerId === NursesTeachers_BG_B || offerId === NursesTeachers_BG_C
  const isPhiloOffer = offerId === PHILO_OFFERID
  const isParamountOffer = offerId === PARAMOUNT_OFFERID
  const isOomaOffer = offerId === OOMA_OFFERID
  const isUniVisionOffer = offerId === UNIVISION_OFFERID
  const isAmazonHintOffer = offerId === AMAZONHINT_OFFERID
  const isAaaOffer = offerId === AAA_OFFERID
  const isTidalOffer = offerId === TIDAL_OFFERID
  const isSiriusOffer = offerId === SIRIUS_OFFERID
  const isGoogleHintOffer = offerId === GOOGLEHINT_OFFERID
  const isCameoSpark = offerId === APPLE_TV_P3
  const isJazzInferno = offerId === APPLE_TV_P4
  return {
    isTVisionOffer,
    isYouTubeBaseOffers,
    isNursesTeachersOffers,
    // addressVisible: !isTVisionOffer && !isAppleFitnessOffer && !isAmazonHintOffer,
    addressVisible: false,
    showNewSubmissionButton: !isTidalOffer && !isTVisionOffer && !isAppleFitnessOffer && !isYouTubeBaseOffers && !isNursesTeachersOffers  && !isPhiloOffer && !isAppleTvOffer && !isParamountOffer && !isAmazonHintOffer && !isUniVisionOffer && !isCameoSpark && !isJazzInferno,
    isPhiloOffer,
    isParamountOffer,
    isOomaOffer,
    isAmazonHintOffer,
    isAaaOffer,
    isTidalOffer,
    isSiriusOffer,
    isUniVisionOffer,
    isGoogleHintOffer,
    isCameoSpark,
    isJazzInferno
  }
}

export const Thanks = (props) => {

  var submissionAlreadyExists = false
  var overrideThanksText = ""

  if (props.history.location.state === undefined || props.history.location.state === null) {
    submissionAlreadyExists = false
  } else if (props.history.location.state.submissionExists) {
    submissionAlreadyExists = props.history.location.state.submissionExists
  }
  const {state} = useContext(AppContext)
  if(!state.campaign.crossDupeCheck){        
    state.campaign.thankYouText = state.campaign.dupeCheckErrorMessage +  "<br><br><br><br> <br><br><br><br> <br><br><br><br>";
  }

  if (submissionAlreadyExists && state.campaign.secondThankYouText) {
    overrideThanksText = state.campaign.secondThankYouText
  }

  const {thankYouText, thankYouTextTwo, offerFormUrl, offerId, thankYouImage, thankYouImageMob, secondThankYouText} = state.campaign
  
  const startNewSubmission = (userOfferID) => {
    switch(userOfferID) {
        case AAA_OFFERID:
            props.history.push(ROUTE_PATHS.AAA)
            break
        default:
            props.history.push(ROUTE_PATHS.DASHBOARD)
            break
    }
  }

  const startNewYtSubmission = () => {
    props.history.push(ROUTE_PATHS.YOUTUBETV)
  }
  const startNewNursesTeachersSubmission = () => {
    props.history.push(ROUTE_PATHS.NursesTeachers)
  }

  const startNewUniVisionSubmission = () => {
    props.history.push(ROUTE_PATHS.UNIVISION)
  }

  const startNewTidalSubmission = () => {
    props.history.push(ROUTE_PATHS.TIDAL)
  }

  const startNewAppleSubmission = () => {
    props.history.push(ROUTE_PATHS.APPLEFITNESS)
  }

  const thankYouTextStyle = {
    maxWidth: "500px",
  }

  const offerConfig = getOfferConfig(offerId)
  const detailsConfig = {
    addressVisible: offerConfig.addressVisible
  }

  const instantValidationOffer = state.iSubmission.instantValidationResult
  const instantValidationError = state.iSubmission.instantValidationResult && state.iSubmission.submissionErrors && state.iSubmission.submissionErrors.length > 0

  const displaySubmission = () => {
    
    if(!state.campaign.crossDupeCheck){
      offerConfig.addressVisible = false
      offerConfig.showNewSubmissionButton = false
      detailsConfig.addressVisible = false
    } else {
        if (!offerConfig.isOomaOffer && !offerConfig.isParamountOffer && !offerConfig.isAaaOffer)
          return <SubmissionDetailsComponent submission={state.iSubmission} config={detailsConfig} />
        else return null
    }
  }
  /* eslint-disable */

  
  return (
    <ThankYouSection useGoogleImages={offerConfig.isGoogleHintOffer} useTidalImages={offerConfig.isTidalOffer} useUniVisionImages={offerConfig.isUniVisionOffer} useTVisionImages={offerConfig.isTVisionOffer} usePhiloImages={offerConfig.isPhiloOffer} useOomaImages={offerConfig.isOomaOffer} useAaaImages={offerConfig.isAaaOffer} useParamountImages={offerConfig.isParamountOffer} useThankyouImage={thankYouImage} useThankyouImageMob={thankYouImageMob} > 
      <div className={`container-fluid ${offerConfig.isTVisionOffer ? "hero2-alt" : "hero2"}`}>
        <div className="row">
          <div className="container mx-auto">
            { state.choseMailIn
              ? <MailInThanksComponent offerFormUrl={offerFormUrl} />
              : <>
                <h1 className={offerConfig.isParamountOffer ? "p-paramount" : ""}>{offerConfig.isAmazonHintOffer ? "Thank You!" : "Thanks."}</h1>

                  { thankYouText !== ""
                    ? <p style={thankYouTextStyle} dangerouslySetInnerHTML={createMarkup(thankYouText)}></p>
                    : "That&apos;s it."
                  }

                  {state.campaign.crossDupeCheck && instantValidationOffer && !instantValidationError && thankYouTextTwo && overrideThanksText.length < 1
                    && <p className={offerConfig.isParamountOffer ? "p-paramount" : ""} style={thankYouTextStyle} dangerouslySetInnerHTML={createMarkup(thankYouTextTwo)}></p> }
                  {state.campaign.crossDupeCheck && instantValidationOffer && !instantValidationError && overrideThanksText.length > 0
                    && <p className={offerConfig.isParamountOffer ? "p-paramount" : ""} style={thankYouTextStyle} dangerouslySetInnerHTML={createMarkup(secondThankYouText)}></p> }
                  
                  
                  {state.campaign.crossDupeCheck && !instantValidationOffer && thankYouTextTwo && !offerConfig.isAaaOffer && <p className={offerConfig.isParamountOffer ? "p-paramount" : ""} style={thankYouTextStyle} dangerouslySetInnerHTML={createMarkup(thankYouTextTwo)}></p> }

                  {instantValidationError && 
                    <>
                      <p>
                        <strong>Sorry, it appears your account is ineligible for this promotion.  Your denial reason is:</strong>
                        <ul>
                        {
                          state.iSubmission.submissionErrors.map(error => <li><strong>{!instantValidationOffer ? error.description : error.nonCompMessage}</strong></li>)
                        }
                        </ul>
                      </p>
                      <br />
                      <br />
                    </>
                  }
                  {state.iSubmission.instantValidationResult && state.iSubmission.instantValidationCodes && ![268651, 268637, 268590, 268683].includes(offerId) &&
                    <div>
                      {/* {!offerConfig.isParamountOffer ? <strong>Reward codes:</strong> : null} */}
                      <br />
                      { state.iSubmission.instantValidationCodes.map(code =>
                        <div style={{marginTop: "1.5rem"}}>
                          <LinkButton primary  className={offerConfig.isParamountOffer ? "btn-paramount" : ""} target="_blank" href={code.instantCodeValue}>
                           {!offerConfig.isParamountOffer ? "Redeem Now" : "New Paramount+ subscriber? Redeem here."}
                          </LinkButton>
                        </div>
                      )}
                      <br />
                    </div>
                  }
                  {(offerId === 268637 && state.campaign.crossDupeCheck) && instantValidationOffer !== "INVALID" &&
                    <div>
                    {state.iSubmission.instantValidationCodes.map(code =>
                        <div key="{code}" style={{marginTop: "1.5rem"}}>
                          <LinkButton primary  className="btn" target="_blank" href={AAA_REWARD_URL+code.instantCodeValue}>
                            Redeem Now
                          </LinkButton>
                        </div>)}
                    </div>
                  }
                  {offerId === 268651 && !instantValidationError &&
                    <div>
                      {state.iSubmission.instantValidationCodes.map(code =>
                        <div style={{ marginTop: "1.5rem" }}>
                          <LinkButton primary className={offerConfig.isParamountOffer ? "btn-paramount" : ""} target="_blank"  href={"https://tv.youtube.com/account_settings/promo_code?coupon_code=" + code.instantCodeValue} >
                          {"Existing YouTube TV Subscriber? Redeem Here"}
                          </LinkButton>
                        </div>
                         )}
                    </div>
                  }

                  {offerId === 268651 && !instantValidationError &&
                    <div>
                      {state.iSubmission.instantValidationCodes.map(code =>
                        <div style={{ marginTop: "1.5rem" }}>
                          <LinkButton primary className={offerConfig.isParamountOffer ? "btn-paramount" : ""} href={"https://tv.youtube.com/tmo_uncarrier?coupon_code=" + code.instantCodeValue} target="_blank">
                            {"New YouTube TV Subscriber? Redeem Here"}
                          </LinkButton>
                          <p className="p-paramount">
                          Apply this code:
                        <b style={{paddingRight: 2}}>{code.instantCodeValue ? code.instantCodeValue: ""}</b>
                        </p>
                        </div>
                      )}
                      <br />
                    </div>
                  }

                  { offerId === 268590 && !instantValidationError && state.iSubmission.instantValidationCodes &&
                    <div>
                      {state.iSubmission.instantValidationCodes.map(code =>
                        <div style={{ marginTop: "1.5rem" }}>
                          <LinkButton primary className={offerConfig.isParamountOffer ? "btn-paramount" : ""} href={"https://tv.youtube.com/welcome/partner/tmobile/?utm_source=tmobile&ac=3GAY4SPBZFDX&coupon_code=" + code.instantCodeValue.split("=")[3]} target="_blank">
                            {"New YouTube TV Subscriber? Redeem Here"}
                          </LinkButton>
                          <p className="p-paramount">
                          Apply this code:
                        <b style={{paddingRight: 2}}>{code.instantCodeValue ? code.instantCodeValue.split("=")[3]: ""}</b>
                        </p>
                        </div>
                      )}
                      <br />
                    </div>
                  }

                {offerId === 268590 && !instantValidationError && state.iSubmission.instantValidationCodes &&
                    <div>
                      {state.iSubmission.instantValidationCodes.map(code =>
                        <div style={{ marginTop: "1.5rem" }}>
                          <LinkButton primary className={offerConfig.isParamountOffer ? "btn-paramount" : ""} target="_blank"  href={"https://tv.youtube.com/tmo_uncarrier?coupon_code=" + code.instantCodeValue.split("=")[3]} >
                          {"Existing YouTube TV Subscriber? Redeem Here"}
                          </LinkButton>
                        </div>
                         )}
                    </div>
                  }
                  
                  {offerConfig.isYouTubeBaseOffers &&
                    <Button className="btn" onClick={() => startNewYtSubmission()} primary>Start a new submission</Button>
                  }
                    {offerConfig.isNursesTeachersOffers &&
                    <Button className="btn" onClick={() => startNewNursesTeachersSubmission()} primary>Start a new submission</Button>
                  }
                   {offerConfig.isTidalOffer &&
                    <Button className="btn" onClick={() => startNewTidalSubmission()} primary>Start a new submission</Button>
                  }
                  
                  {offerConfig.isUniVisionOffer &&
                    <Button className="btn" onClick={() => startNewUniVisionSubmission()} primary>Start a new submission</Button>
                  }

                  {(offerConfig.isCameoSpark || offerConfig.isJazzInferno) &&
                    <Button className="btn" style={{ fontWeight: "600" }} onClick={() => startNewAppleSubmission()} primary>Submit for another offer</Button>
                  }
                  
                  {offerConfig.isParamountOffer &&
                    state.iSubmission.instantValidationCodes &&
                    state.iSubmission.instantValidationCodes.map(code =>
                      <>
                        <LinkButton className="btn-paramount" href="https://www.paramountplus.com/account" target="_blank" primary>Existing Paramount+ Essential monthly subscriber? Use code below and Redeem here.</LinkButton>
                        <p className="p-paramount">
                          Apply this code:
                          <br/>
                          <b>{code.instantCodeValue ? code.instantCodeValue.split("=")[1] : ""}</b>
                          <br/>
                          in your account under "Redeem a Coupon"
                        </p>

                        <p className="p-paramount">
                          <b>All other existing Paramount+ subscribers, <br/>click <a href="https://www.t-mobile.com/offers/paramount-plus-deal#paramount-plus-faq" target="_blank" rel="noopener noreferrer">here</a> before redeeming offer.</b>
                        </p>
                      </>
                    )
                  }

                  {
                    offerConfig.isGoogleHintOffer && !instantValidationError && 
                    <div>
                      {state.iSubmission.instantValidationCodes.map(code =>
                        <div style={{ marginTop: "1.5rem" }}>
                          <LinkButton primary target="_blank"  href={code.instantCodeValue} >
                            Redeem Now
                          </LinkButton>
                        </div>
                         )}
                    </div>
                  }

                  {displaySubmission()}

                  
                </>
            }
            { offerConfig.showNewSubmissionButton && !offerConfig.isOomaOffer ?
              <div className="pt-3">
                <Button className="btn" onClick={() => startNewSubmission(offerId)} primary>Start new submission</Button>
              </div>
            : null}

            {offerConfig.isGoogleHintOffer && <p>Google and Nest Wifi are trademarks of Google LLC</p>}
          </div>
        </div>
      </div>
    </ThankYouSection>
  )
}

Thanks.propTypes = {
  history: PropTypes.object
}

Thanks.requiresAuth = true
